module.exports = __webpack_public_path__ + "static/content-05-45bc10314678732540225ccd766bffa0.jpg";